import React, { useState } from 'react';
import { APP_BASE_URL } from '../../config';
import { formatTimeAgo, formatExactDate } from '@utils/timeUtils';
import UserAvatar from '@uiElements/UserAvatar';

const HistoryItem = ({ item }) => {
  const {
    col,
    old_val,
    new_val,
    old_desc,
    new_desc,
    old_date,
    new_date,
    action_type,
    name,
    activity_date,
    description,
    user_id,
    photo,
  } = item;

  const isDescription = col === 'description';
  const oldContent = isDescription ? old_desc : old_val;
  const newContent = isDescription ? new_desc : new_val;

  const displayOld = oldContent || 'Unknown';
  const displayNew = newContent || 'Unknown';

  const label =
    action_type ||
    `${col.replace(/_/g, ' ')} changed`;

  const [showFull, setShowFull] = useState(false);
  const toggleHtml = () => setShowFull(prev => !prev);

  const avatar = photo
    ? `${APP_BASE_URL}/uploads/profilephoto/${user_id}/profilePic/${photo}`
    : null;

  /** ---------- FIX #3: Updated change formatter ---------- **/
  const formattedChange = () => {
    if (isDescription) {
      return (
        <>
          <div className="text-gray-500 text-xs mb-1">Description changed</div>
          <div
            className="prose prose-sm max-w-none bg-gray-50 rounded px-3 py-2 border"
            dangerouslySetInnerHTML={{ __html: showFull ? newContent : (newContent || '').slice(0, 100) + '...' }}
          />
          {newContent?.length > 100 && (
            <button
              className="text-xs text-blue-600 mt-1 hover:underline"
              onClick={toggleHtml}
            >
              {showFull ? 'Show less' : 'Show more'}
            </button>
          )}
        </>
      );
    }

    return (
      <div>
        <span className="text-sm text-gray-700">
          <strong>{label}</strong> from{" "}
          <span className="text-red-600 font-medium">{displayOld}</span> to{" "}
          <span className="text-green-600 font-medium">{displayNew}</span>
        </span>
      </div>
    );
  };

  return (
    <div className="flex items-start gap-3 mb-6 relative">
      {/* Vertical Timeline Line */}
      <div className="w-10 flex justify-center relative">
        <div className="absolute top-0 bottom-0 left-1/2 border-l-2 border-gray-200 transform -translate-x-1/2" />

        <UserAvatar
        className="mt-1 relative group"
          name={name}
          imageUrl={avatar}
          size={32}
        />
      </div>

  {/* Right Content */}
  <div className="flex-1">
    {formattedChange()}
    <div className="text-xs text-gray-500 mt-1 flex items-center gap-2">
      <span>
        By <strong>{name}</strong>
      </span>
      <span title={formatExactDate(activity_date)}>{formatTimeAgo(activity_date)}</span>
    </div>
  </div>
</div>

  );
};

export default HistoryItem;
